/**
 * mwApp.preferences module <br>
 * Edit account's preferences
 *
 * @namespace mwApp/preferences
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/preferences
 * @see mwApp/preferences
 *
 * @ngdoc config
 * @name mwApp/preferences.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /preferences
     */
    .state('app.preferences', {
      abstract: true,
      url: '/preferences',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/preferences.controller:PreferencesCtrl}
     * @name /preferences
     * @memberof mwApp/preferences.config:ConfigRoutes
     */
    .state('app.preferences.main', {
      url: '',
      templateUrl: 'components/preferences/views/preferences.html',
      controller: 'PreferencesCtrl as vm',
      label: 'Preferences',
      access: '' // == 'authenticated', means user should be authenticated
    })
}
